import React from 'react';
const featureCards = [{
  src: 'https://cdn.magicpatterns.com/uploads/mJfgKhqMYGDfS8WZ1kdaC9/Copia_de_Celebrate_Shopify_-_Square_(17).png',
  alt: '+10,000 Premium Designs - All the characters your kids love'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rCTEK9xaGuKuA9b8AUocRF/Copia_de_Celebrate_Shopify_-_Square_(19).png',
  alt: 'Complete Decoration Kit - Invitations, toppers, boxes, banners, stickers, and more'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/s6DpJtWAYekxQ7q2dQSPJE/Copia_de_Celebrate_Shopify_-_Square_(18).png',
  alt: 'Easy to use - PDF, PNG, SVG and DXF formats, editable from your phone with free Canva'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/aBpgdsbZF8b6Q73qRosD7d/Copia_de_Celebrate_Shopify_-_Square_(21).png',
  alt: 'Business opportunity - Turn your talent into extra income decorating parties'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/paSaubN3KhWmbtZTWv5HXt/Copia_de_Celebrate_Shopify_-_Square_(20).png',
  alt: 'Immediate download - Instant access via email, start using everything today'
}];
export function WhatsIncluded() {
  return <section className="py-16 px-4 bg-white" data-id="element-475">
      <div className="max-w-5xl mx-auto" data-id="element-476">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-teal-500 mb-12" data-id="element-477">
          ⭐ WHAT'S INCLUDED IN THE KIT?
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-478">
          {featureCards.map((card, index) => <div key={index} className={`rounded-3xl overflow-hidden shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 ${index === featureCards.length - 1 && featureCards.length % 3 !== 0 ? 'sm:col-span-2 lg:col-span-1' : ''}`} data-id="element-479">
              <img src={card.src} alt={card.alt} className="w-full h-full object-cover aspect-square" data-id="element-480" />
            </div>)}
        </div>
      </div>
    </section>;
}